export default "__VITE_ASSET__0c05c80b__"